import Nav from "@components/nav/Nav.component";
import { Outlet } from "react-router-dom";
import logo from '../assets/images/pliable/logo_with_text.png';

const Welcome = () => {
    return <>Welcome</>
}

export default Welcome;